module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_08_stay-021704331b046c587ced2df49c5ccdfa.jpg";